import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const checkboxWrapper = "omponents__Checkbox__Checkbox_styles_ts-checkboxWrapper-csxs4df";
export const checkboxLabel = "omponents__Checkbox__Checkbox_styles_ts-checkboxLabel-c126c4zd";
export const checkboxDefault = "omponents__Checkbox__Checkbox_styles_ts-checkboxDefault-cuxvvu8";

require("./Checkbox_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Checkbox_styles.ts");